import { render, staticRenderFns } from "./message.vue?vue&type=template&id=b7e0a120&scoped=true"
import script from "./message.vue?vue&type=script&lang=ts"
export * from "./message.vue?vue&type=script&lang=ts"
import style0 from "./message.vue?vue&type=style&index=0&id=b7e0a120&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e0a120",
  null
  
)

export default component.exports